import BaseSelect from 'components/molecules/select/base';
import { useTranslation } from 'react-i18next';

import type { ClinicReviewTimeData } from './hooks/useData';

interface Props {
  list: ClinicReviewTimeData[];
  onSelect: (clinicGuid?: string) => void;
  value: ClinicReviewTimeData | null;
}

export const ClinicSelect = ({ list, onSelect, value }: Props) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        paddingBottom: '16px',
      }}
    >
      <BaseSelect
        showSearch
        options={list.map((item) => ({
          label: item.clinicName,
          value: item.clinicGuid,
        }))}
        label={t('labels.clinics')}
        allowClear={false}
        value={{
          label: value?.clinicName,
          value: value?.clinicGuid,
        }}
        onChange={(item) => {
          const selectedItem = Array.isArray(item) ? item[0] : item;
          onSelect(selectedItem.value);
        }}
      />
    </div>
  );
};
